import React, { useState } from 'react';
import Modal from 'react-modal';
import './serviceFormRegister.css';
import { MdOutlineClose } from 'react-icons/md';
import Email_sent from '../../../assets/success_email.svg';
import img1 from '../../../assets/success_popup_img1.svg';
import img2 from '../../../assets/service_popup_img_2.svg';
import img3 from '../../../assets/success_popup_img3.svg';
import $ from 'jquery';

// Modal.setAppElement("#yourAppElement");

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '70%',
		borderRadius: '20px',
		minHeight: '60vh',
		maxHeight: '83vh',
		overflow: 'hidden',
		padding: '0px',
	},
};

function ServiceFormRegister({ isOpen, onRequestClose }) {
	const [btnId, setBtnId] = useState();

	const btnIdTimeOut = () => {
		setBtnId();
	};
	const localStorages = () => {
		localStorage.setItem('close', 'true');
		$('.ReactModal__Overlay').addClass('d-none');
		localStorage.clear();
	};

	$('.popup_model_onScroll').addClass('popup_model_onScroll_bg');
	const scrollFn = () => {
		$('.popup_model_onScroll').removeClass('popup_model_onScroll_bg');
		setTimeout(fadeInFn, 1000);
	};
	const fadeInFn = () => {
		$('.popup_model_onScroll').addClass('popup_model_onScroll_bg');
	};

	return (
		<div className='popups'>
			<Modal
				isOpen={isOpen}
				onRequestClose={onRequestClose}
				style={customStyles}
				contentLabel='Example Modal'>
				{' '}
				<div
					className=' popup_model_onScroll popup_model_onScroll_bg fade_in'
					onScroll={scrollFn}>
					<div className='p-3'>
						<button
							onClick={localStorages}
							className='border-0 bg-white text-rigth w-100 d-flex justify-content-end'>
							<p
								className='display-6 fw-2 mt-0'
								style={{
									fontWeight: '500',
									color: '#3C3C3C',
									fontSize: '30px',
									opacity: '0.8',
								}}>
								<MdOutlineClose />
							</p>
						</button>
						<div className='mt-lg-2'>
							<div className='d-flex justify-content-center'>
								{' '}
								<img
									src={Email_sent}
									width='113'
									height='86'
									className='email_success'
									alt='email success'
									title='success mail'></img>
							</div>
							<h1 className='pt-lg-5 mainHead'>
								We have emailed you. Please check your inbox{' '}
							</h1>
							<div className='mt-lg-5 mt-3'>
								<div className='d-flex align-items-center mt-lg-4 mt-3 mx-md-3 mx-2'>
									<img
										src={img1}
										width='42'
										height='42'
										alt='icon'
										title='icon'></img>
									<p className='m-0 ms-3 para_sentence'>
										We have alloted a business consultant for you.
									</p>
								</div>
								<div className='d-flex align-items-center mt-lg-4 mt-3 mx-md-3 mx-2'>
									<img
										src={img2}
										width='42'
										height='42'
										alt='icon'
										title='icon'></img>
									<p className='m-0 ms-3 para_sentence'>
										Check your email and download the attachments to know what
										to do next
									</p>
								</div>
								<div className='d-flex align-items-center my-lg-4 mt-3 mx-md-3 mx-2'>
									<img
										src={img3}
										width='42'
										height='42'
										alt='icon'
										title='icon'></img>
									<p className='m-0 ms-3 para_sentence'>
										Our consultant will call you for personal discussion
									</p>
								</div>
							</div>
						</div>{' '}
					</div>
				</div>
			</Modal>
		</div>
	);
}

export default ServiceFormRegister;
